import React, { useMemo } from 'react'

import { GenericError, handleFetchMore } from '@sketch/components'
import { dataIdFromObject } from '@sketch/graphql-cache'

import { PublicationQueryPreferencesFragment } from '@sketch/gql-types'

import PublicationGrid, { PublicationGridPlaceholder } from '../PublicationGrid'
import { useGetCommunityPublications } from '../../hooks/useGetCommunityPublications'

const ENTRIES_PATH = ['publications', 'entries']

interface CommunityPublicationGridProps {
  preferences: Partial<PublicationQueryPreferencesFragment> | null
}

const CommunityPublicationGrid = (props: CommunityPublicationGridProps) => {
  const { preferences } = props
  const { allowPagination } = preferences || {}

  const { data, loading, error, fetchMore } = useGetCommunityPublications({
    preferences,
  })

  const after = data?.publications.meta.after

  const handleLoadMore = useMemo(
    () =>
      handleFetchMore(fetchMore, ENTRIES_PATH, {
        dataIdFromObject,
        after,
      }),
    [fetchMore, after]
  )

  if (loading) {
    return <PublicationGridPlaceholder />
  }

  if (error || !data) {
    return <GenericError />
  }

  const publications = data.publications
  const items = publications.entries || []

  const placeholderCount = allowPagination
    ? Math.max(Math.min(publications.meta.totalCount - items.length, 20), 0)
    : 0

  return (
    <PublicationGrid
      items={items}
      placeholderCount={placeholderCount}
      onLoadMore={allowPagination ? handleLoadMore : undefined}
    />
  )
}

export default CommunityPublicationGrid
